import { render } from "./comapanyManage.vue?vue&type=template&id=3d511d3e&scoped=true&ts=true"
import script from "./comapanyManage.vue?vue&type=script&lang=ts"
export * from "./comapanyManage.vue?vue&type=script&lang=ts"

import "./comapanyManage.vue?vue&type=style&index=0&id=3d511d3e&lang=less&scoped=true"

import exportComponent from "E:\\Projects\\v3-admin-all\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d511d3e"]])

export default __exports__